/* The Library, from Main.dc.html (laptop) and PhoneLibrary.dc.html (phone). */

/* Product accents for the small dots, from the tokens file */
.dot { width: 8px; height: 8px; border-radius: 4px; flex-shrink: 0; display: inline-block; }
.dot--small { width: 7px; height: 7px; }
.dot--ring { box-shadow: 0 0 0 1px var(--shell-ink-20); }
.dot--fe { background: var(--accent-fe); }
.dot--acc { background: var(--accent-acc); }
.dot--pcfl { background: var(--accent-pcfl); }
.dot--poyt { background: var(--accent-poyt); }
.dot--master { background: var(--accent-master); }

/* The payment banner */
.lib-banner {
  display: flex; align-items: center; justify-content: space-between; gap: 24px; padding: 16px var(--gutter);
  background: var(--shell-ink-04); border-bottom: 1px solid var(--shell-ink-12); box-shadow: inset 4px 0 0 var(--shell-gold);
}
.lib-banner-text { display: flex; align-items: center; gap: 14px; font-size: 15px; line-height: 1.5; }
.lib-banner-btn {
  flex-shrink: 0; height: 40px; padding: 0 18px; border-radius: 10px; background: var(--shell-ink); color: var(--shell-on-ink);
  font-weight: 700; font-size: 14px; display: flex; align-items: center; text-decoration: none;
}
.lib-banner-btn:hover { color: var(--shell-on-ink); }
.lib-banner--phone { flex-direction: column; align-items: stretch; gap: 12px; padding: 14px 16px 14px 20px; }
.lib-banner--phone .lib-banner-btn { justify-content: center; height: 44px; }

.lib-loading { flex: 1; min-height: 60vh; }

/* Laptop */
/* the board's footer sits inside main's 120px bottom padding, 48px below the last section */
.lib-main { flex: 1; padding: 48px var(--gutter) 48px; display: flex; flex-direction: column; gap: 44px; }
.lib-hello { display: flex; flex-direction: column; gap: 8px; }
.lib-date { font-size: 13px; letter-spacing: 0.14em; text-transform: uppercase; color: var(--shell-ink-60); font-weight: 700; }
.lib-h1 { margin: 0; font-size: 44px; font-weight: 800; letter-spacing: -0.01em; }
.lib-h2 { margin: 0; font-size: 13px; letter-spacing: 0.14em; text-transform: uppercase; color: var(--shell-ink-60); font-weight: 700; }
.lib-section { display: flex; flex-direction: column; gap: 16px; }
.lib-section-head { display: flex; align-items: baseline; justify-content: space-between; gap: 24px; }
.lib-all { font-size: 14px; font-weight: 700; color: var(--shell-ink); }
.lib-join { margin: -20px 0 0; font-size: 15px; color: var(--shell-ink-60); }
/* nothing above it to sit under: someone with no tiles at all */
.lib-join--alone { margin: 0; }

.lib-news {
  display: flex; align-items: center; justify-content: space-between; gap: 24px; padding: 20px 24px; border-radius: 14px;
  border: 1px solid var(--shell-ink-12); box-shadow: inset 4px 0 0 var(--shell-gold);
}
.lib-news-text { display: flex; flex-direction: column; gap: 6px; }
.lib-news-from { font-size: 12px; font-weight: 700; letter-spacing: 0.14em; text-transform: uppercase; color: var(--shell-ink-60); }
.lib-news-head { font-size: 18px; font-weight: 700; line-height: 1.4; }
.lib-news-line { font-size: 15px; line-height: 1.55; color: var(--shell-ink-66); }
.lib-news-actions { display: flex; gap: 10px; align-items: center; flex-shrink: 0; }
.lib-news-btn {
  height: 42px; padding: 0 16px; border-radius: 10px; background: var(--shell-ink); color: var(--shell-on-ink);
  font-weight: 700; font-size: 14px; display: flex; align-items: center; text-decoration: none;
}
.lib-news-btn:hover { color: var(--shell-on-ink); }
.lib-news-hide {
  width: 42px; height: 42px; border-radius: 10px; border: 1px solid var(--shell-ink-16); background: transparent;
  color: var(--shell-ink); display: flex; align-items: center; justify-content: center;
}
.lib-news-hide:disabled, .ph-news-hide:disabled { opacity: 0.55; } /* the shell's 1 disabled look, as Account's */

.lib-next {
  display: flex; align-items: center; justify-content: space-between; gap: 32px; padding: 32px 36px; border-radius: 18px;
  background: var(--shell-ink-03); border: 1px solid var(--shell-ink-10);
}
.lib-next-text { display: flex; flex-direction: column; gap: 10px; max-width: 700px; }
.lib-next-eyebrow {
  display: flex; align-items: center; gap: 10px; font-size: 13px; font-weight: 700; letter-spacing: 0.14em;
  text-transform: uppercase; color: var(--shell-ink);
}
.lib-next-title { font-size: 28px; font-weight: 700; line-height: 1.25; }
.lib-next-line { font-size: 16px; line-height: 1.55; color: var(--shell-ink-66); }
.lib-next-actions { display: flex; gap: 12px; flex-shrink: 0; }

.grid { display: grid; gap: 20px; }
.grid--4 { grid-template-columns: repeat(4, minmax(0, 1fr)); }
.grid--3 { grid-template-columns: repeat(3, minmax(0, 1fr)); }

/* Date blocks: Coming up and Free webinars */
.dblock { width: 52px; flex-shrink: 0; display: flex; flex-direction: column; align-items: center; gap: 2px; padding-top: 2px; }
.dblock-edge { font-size: 12px; font-weight: 700; letter-spacing: 0.1em; color: var(--shell-ink-60); }
.dblock-day { font-size: 30px; font-weight: 800; line-height: 1.1; }
.dblock--small { width: 44px; gap: 0; padding-top: 0; }
.dblock--small .dblock-edge { font-size: 11px; letter-spacing: 0.08em; }
.dblock--small .dblock-day { font-size: 22px; line-height: 1.15; }

.session { display: flex; flex-direction: column; gap: 14px; padding: 18px; border-radius: 14px; border: 1px solid var(--shell-ink-10); min-height: 128px; }
.session-top { display: flex; gap: 16px; }
/* Join and Add to calendar (design 5.3), along the card's foot so the 4 cards line up */
.session-actions { margin-top: auto; display: flex; flex-wrap: wrap; gap: 8px; }
.session-btn {
  height: 36px; padding: 0 12px; border-radius: 8px; border: 1px solid var(--shell-ink-20); background: transparent;
  color: var(--shell-ink); font-weight: 700; font-size: 13px; display: inline-flex; align-items: center; text-decoration: none; white-space: nowrap;
}
.session-btn--ink { background: var(--shell-ink); border-color: var(--shell-ink); color: var(--shell-on-ink); padding: 0 16px; }
.session-btn--ink:hover { color: var(--shell-on-ink); }
.session-text { display: flex; flex-direction: column; gap: 6px; min-width: 0; }
.session-product { display: flex; align-items: center; gap: 8px; font-size: 13px; color: var(--shell-ink-66); }
.session-title { font-size: 16px; font-weight: 700; line-height: 1.3; }
.session-time { font-size: 14px; color: var(--shell-ink-66); }

/* Product tiles */
.ptile {
  display: flex; flex-direction: column; border-radius: 16px; overflow: hidden; border: 1px solid var(--shell-ink-10);
  background: var(--shell-ink-02); text-decoration: none; color: var(--shell-ink);
}
.ptile:hover, .wcard:hover, .fcard:hover { border-color: var(--shell-ink-30); }
.tile-body { padding: 18px 18px 20px; display: flex; flex-direction: column; gap: 7px; }
.tile-kind { font-size: 11px; font-weight: 700; letter-spacing: 0.14em; text-transform: uppercase; color: var(--shell-ink-60); }
.tile-name { font-size: 16px; font-weight: 700; }
.tile-status { font-size: 14px; color: var(--shell-ink-66); }
.tile-status--strong { color: var(--shell-ink); }
/* A portal card's line: the site it opens, with the small out-arrow (Adam, 10 Oct) */
.tile-status--out, .prow-status--out { display: flex; align-items: center; gap: 6px; }
.tile-status--out .icon-line, .prow-status--out .icon-line { flex-shrink: 0; }
/* A mastermind's line: where they stand, in ink and bold, then the status (the Accelerator critique's member 17,
   22 Oct). The master brand's own: gold never carries it */
.tile-line { font-size: 14px; color: var(--shell-ink-66); }
.prow-line { font-size: 13px; color: var(--shell-ink-66); }
.tile-level { color: var(--shell-ink); font-weight: 700; }
.bar { display: block; height: 4px; border-radius: 2px; background: var(--shell-ink-10); margin-top: 8px; }
.bar--phone { margin-top: 6px; }
.bar-fill { display: block; height: 4px; border-radius: 2px; background: var(--shell-gold); }
.tile-pct { font-size: 12px; color: var(--shell-ink-60); }

/* Tile art, laptop: each product in its own look */
.art { height: 176px; padding: 20px; display: flex; flex-direction: column; justify-content: space-between; position: relative; }
.art--fe { background: var(--fe-bg); }
.art-fe-bar { width: 36px; height: 4px; background: var(--fe-green); }
.art-fe-name { font-family: 'Anton', sans-serif; font-size: 32px; line-height: 1.02; color: var(--fe-text); letter-spacing: 0.01em; }
.art-fe-cohort { font-family: 'Archivo', sans-serif; font-size: 13px; font-weight: 500; color: var(--fe-muted); min-height: 1em; }
.art--acc { background: var(--acc-bg); }
.art-acc-cohort { font-family: 'Inter', sans-serif; font-size: 12px; font-weight: 600; letter-spacing: 0.08em; text-transform: uppercase; color: var(--acc-soft); min-height: 1em; }
.art-acc-name { font-family: 'Inter Tight', sans-serif; font-size: 23px; font-weight: 700; line-height: 1.15; color: var(--acc-green); }
.art-acc-rule { height: 1px; background: var(--acc-rule); }
.art--masterclass { background: var(--poyt-orange); justify-content: flex-end; }
.art-mc-name { font-family: 'Archivo', sans-serif; font-size: 24px; font-weight: 800; line-height: 1.12; color: var(--on-dark); }
.art--pcfl { padding: 0; overflow: hidden; background: var(--acc-green); }
.art--pcfl img { width: 100%; height: 100%; object-fit: cover; }
.art-pcfl-chip {
  position: absolute; left: 12px; right: 12px; bottom: 12px; padding: 11px 13px; background: var(--acc-green);
  border-radius: 10px; display: flex; align-items: center; gap: 10px;
}
.art-pcfl-chip .pentagon { flex-shrink: 0; }
.art-pcfl-chip span { font-family: 'Inter Tight', sans-serif; font-weight: 700; font-size: 14px; color: var(--on-dark); line-height: 1.2; }
.art--poyt { background: var(--poyt-navy); }
.art-poyt-eyebrow { font-family: 'IBM Plex Sans', sans-serif; font-size: 12px; font-weight: 600; letter-spacing: 0.16em; text-transform: uppercase; color: var(--poyt-soft-on-navy); }
.art-poyt-name { font-family: 'Archivo', sans-serif; font-size: 25px; font-weight: 800; line-height: 1.12; color: var(--on-dark); }
.poyt-underline { position: relative; display: inline-block; }
.poyt-underline > span { position: absolute; background: var(--poyt-orange); transform: skewX(-12deg); }
.poyt-underline--tile > span { left: -2px; right: -4px; bottom: -5px; height: 4px; }
.poyt-underline--phone > span { left: -1px; right: -3px; bottom: -3px; height: 3px; }
.art--master { background: var(--shell-ink-03); justify-content: flex-start; gap: 16px; }
.art-master-bar { width: 36px; height: 4px; background: var(--shell-gold); }
.art-master-name { font-size: 24px; font-weight: 800; line-height: 1.15; color: var(--shell-ink); }

.art-lock {
  position: absolute; inset: 0; background: var(--shell-veil); display: flex; flex-direction: column;
  align-items: center; justify-content: center; gap: 10px; color: var(--shell-ink); text-align: center; padding: 8px;
}
.art-lock span { font-size: 15px; font-weight: 700; }
.art-lock--small { gap: 4px; }
.art-lock--small span { font-size: 12px; }

/* Free webinars and Free resources cards */
.wcard { display: flex; gap: 16px; padding: 18px; border-radius: 14px; border: 1px solid var(--shell-ink-10); text-decoration: none; color: var(--shell-ink); }
.webinar-action { margin-top: auto; padding-top: 4px; font-size: 14px; font-weight: 700; display: flex; align-items: center; gap: 6px; }
.fcard { display: flex; align-items: center; gap: 16px; padding: 14px; border-radius: 14px; border: 1px solid var(--shell-ink-10); text-decoration: none; color: var(--shell-ink); }
.free-text { display: flex; flex-direction: column; gap: 4px; min-width: 0; }
.free-name { font-size: 15px; font-weight: 700; line-height: 1.3; }
.free-action { font-size: 14px; font-weight: 700; display: flex; align-items: center; gap: 6px; }
.glyph {
  width: 76px; height: 76px; flex-shrink: 0; border-radius: 10px; border: 1px solid;
  font-size: 30px; font-weight: 800; display: flex; align-items: center; justify-content: center;
}
.glyph--small { width: 56px; height: 56px; border-radius: 9px; font-size: 22px; }
/* an item's own cover photo (3 Nov), cropped to fill the square; the panel shows while it's on its way */
.glyph--cover { position: relative; overflow: hidden; background: var(--shell-ink-04); border-color: var(--shell-ink-10); }
.glyph-img { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover; display: block; }
.glyph--acc-light { background: var(--acc-bg); color: var(--acc-green); border-color: var(--acc-rule); }
.glyph--acc-solid { background: var(--acc-green); color: var(--on-dark); border-color: var(--acc-green); }
.glyph--master-light { background: var(--shell-tile-light); color: var(--shell-ink); border-color: var(--shell-ink-10); }
.glyph--master-solid { background: var(--shell-ink); color: var(--shell-on-ink); border-color: var(--shell-ink); }
.glyph--fe-light { background: var(--fe-surface); color: var(--fe-text); border-color: var(--fe-surface); }
.glyph--fe-solid { background: var(--fe-green); color: var(--fe-on-green); border-color: var(--fe-green); }
.glyph--poyt-light { background: var(--poyt-paper); color: var(--poyt-ink); border-color: var(--poyt-line); }
.glyph--poyt-solid { background: var(--poyt-navy); color: var(--on-dark); border-color: var(--poyt-navy); }

/* Free webinars (Adam, 9 Oct): Coming up, then Watch again, each under its own sub-label, with Adam's
   own 16:9 thumbnails. --rail-gutter is the page's side gutter, which a phone's rail runs into. */
.lib-main { --rail-gutter: var(--gutter); }
.ph-main { --rail-gutter: 16px; }
.lib-web { gap: 18px; }
.lib-web-part { display: flex; flex-direction: column; gap: 12px; min-width: 0; }
.lib-sub { margin: 0; font-size: 15px; font-weight: 800; line-height: 1.3; color: var(--shell-ink); }

/* The 16:9 frame: the thumbnail filling it, or the light grey panel with the date block in the middle */
.thumb {
  position: relative; display: flex; align-items: center; justify-content: center; width: 100%; aspect-ratio: 16 / 9;
  overflow: hidden; background: var(--shell-ink-04); flex-shrink: 0;
}
.thumb-img { position: absolute; inset: 0; width: 100%; height: 100%; object-fit: cover; display: block; }
.thumb-fallback { display: flex; align-items: center; justify-content: center; }
.thumb .dblock { padding-top: 0; }
.thumb .dblock-day { font-size: 34px; }

/* A webinar's card with its thumbnail */
.wthumb {
  display: flex; flex-direction: column; min-width: 0; border-radius: 14px; overflow: hidden; border: 1px solid var(--shell-ink-10);
  background: var(--shell-bg); text-decoration: none; color: var(--shell-ink);
}
.wthumb:hover { border-color: var(--shell-ink-30); }
.wthumb .thumb { border-bottom: 1px solid var(--shell-ink-07); }
.wthumb-body { display: flex; flex-direction: column; gap: 5px; padding: 14px 16px 16px; flex-grow: 1; min-width: 0; }
.wthumb-kind { display: flex; align-items: center; gap: 8px; font-size: 13px; color: var(--shell-ink-66); }
.wthumb-date { font-size: 13px; color: var(--shell-ink-66); }
.wthumb-title { font-size: 16px; font-weight: 700; line-height: 1.3; overflow-wrap: anywhere; }
.wthumb-action { margin-top: auto; padding-top: 6px; font-size: 14px; font-weight: 700; display: flex; align-items: center; gap: 6px; }

/* Coming up's thumbnail cards: 3 across on a laptop, wrapping */
.wgrid { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 20px; }

/* Watch again (Adam, 11 Oct): 1 row that scrolls sideways inside itself, never the page, snapping to a
   card's start, 3 whole cards at a time on a laptop. The row clips what's outside it, so 4px all round
   keep a card's focus ring (2px, 2px out) whole, given back by its margin so the cards line up with the
   rest of the page and the spacing stays the same. No scrollbar: the arrows, a trackpad, shift and the
   wheel, and the keyboard's Tab move it. */
.wrail {
  display: flex; gap: 20px; overflow-x: auto; overscroll-behavior-x: contain; scroll-snap-type: x mandatory;
  margin: -4px; padding: 4px; scroll-padding-inline: 4px;
  scrollbar-width: none; -webkit-overflow-scrolling: touch;
}
.wrail::-webkit-scrollbar { display: none; }
.wrail > .wthumb { flex: 0 0 calc((100% - 40px) / 3); scroll-snap-align: start; }

/* The sub-label's line: Watch again, then See all and the 2 arrow buttons at the right. The tools
   add only a few px to the line's height, so the cards sit about where they did. */
.lib-sub-head { display: flex; align-items: center; justify-content: space-between; gap: 16px; min-width: 0; }
.wrow-tools { display: flex; align-items: center; gap: 8px; margin-block: -4px; flex-shrink: 0; }
.wrow-all { margin-right: 8px; }
.wrow-btn {
  width: 36px; height: 36px; padding: 0; border-radius: 10px; border: 1px solid var(--shell-ink-20); background: var(--shell-bg);
  color: var(--shell-ink); display: inline-flex; align-items: center; justify-content: center;
}
.wrow-btn:hover { border-color: var(--shell-ink-30); background: var(--shell-ink-04); }
/* the shell's 1 disabled look, as Account's; still focusable, so a keyboard's focus stays put */
.wrow-btn[aria-disabled="true"] { opacity: 0.55; cursor: default; }
.wrow-btn[aria-disabled="true"]:hover { border-color: var(--shell-ink-20); background: var(--shell-bg); }

/* Between a laptop and a phone: the same Library, 2 to a row */
@media (max-width: 1180px) {
  .grid--4 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .grid--3 { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .wgrid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .wrail > .wthumb { flex-basis: calc((100% - 20px) / 2); }
  .lib-next, .lib-news { flex-direction: column; align-items: flex-start; }
}

/* A phone (PHONE_QUERY's 760px and under, where the Library is its phone layout): Coming up's cards
   stacked, and Watch again a rail to swipe, edge to edge, each card 80% of the width so the next one
   always shows at the right edge, with no arrows. Only the rail scrolls sideways, never the page. A
   replay on its own takes the whole width. 4px above and below the cards keep their focus ring whole,
   as wider. */
@media (max-width: 760px) {
  .wgrid { grid-template-columns: minmax(0, 1fr); gap: 12px; }
  .wrail {
    gap: 12px;
    margin-inline: calc(-1 * var(--rail-gutter)); padding-inline: var(--rail-gutter); scroll-padding-inline: var(--rail-gutter);
  }
  .wrail > .wthumb { flex-basis: 80%; }
  .wrail > .wthumb:only-child { flex-basis: 100%; }
  .lib-sub-head { align-items: baseline; }
  .wrow-tools { margin-block: 0; }
  .wrow-all { margin-right: 0; }
}

/* Phone */
.ph-main { flex: 1; }
.ph-hello { padding: 22px 16px 18px; display: flex; flex-direction: column; gap: 4px; }
.ph-date { font-size: 12px; font-weight: 700; letter-spacing: 0.14em; text-transform: uppercase; color: var(--shell-ink-60); }
.ph-h1 { font-size: 30px; font-weight: 800; letter-spacing: -0.01em; }

.ph-news {
  margin: 0 16px 16px; padding: 16px 16px 18px 20px; border-radius: 14px; border: 1px solid var(--shell-ink-12);
  box-shadow: inset 4px 0 0 var(--shell-gold); display: flex; flex-direction: column; gap: 8px;
}
.ph-news-top { display: flex; align-items: center; justify-content: space-between; gap: 12px; }
.ph-news-from { font-size: 11px; font-weight: 700; letter-spacing: 0.14em; text-transform: uppercase; color: var(--shell-ink-60); }
.ph-news-hide {
  width: 44px; height: 44px; flex-shrink: 0; border-radius: 10px; border: 1px solid var(--shell-ink-16);
  background: transparent; color: var(--shell-ink); display: flex; align-items: center; justify-content: center;
}
.ph-news-head { font-size: 17px; font-weight: 700; line-height: 1.4; }
.ph-news-line { font-size: 14px; line-height: 1.5; color: var(--shell-ink-66); }
.ph-btn {
  height: 46px; border-radius: 10px; background: var(--shell-ink); color: var(--shell-on-ink); font-weight: 700; font-size: 15px;
  display: flex; align-items: center; justify-content: center; text-decoration: none;
}
.ph-btn:hover { color: var(--shell-on-ink); }
.ph-btn--news { margin-top: 4px; }
.ph-btn--next { height: 48px; margin-top: 6px; }
/* Next up's own button while its Join shows: Join is the black one */
.ph-btn--line { background: transparent; color: var(--shell-ink); border: 1px solid var(--shell-ink-20); }
.ph-btn--line:hover { color: var(--shell-ink); }
.ph-btn-line {
  height: 46px; border-radius: 10px; border: 1px solid var(--shell-ink-20); background: transparent;
  color: var(--shell-ink); font-weight: 700; font-size: 15px;
}

.ph-next {
  margin: 0 16px; padding: 22px 20px; border-radius: 16px; background: var(--shell-ink-03);
  border: 1px solid var(--shell-ink-10); display: flex; flex-direction: column; gap: 10px;
}
.ph-next-eyebrow {
  display: flex; align-items: center; gap: 8px; font-size: 12px; font-weight: 700; letter-spacing: 0.14em;
  text-transform: uppercase; color: var(--shell-ink);
}
.ph-next-title { font-size: 20px; font-weight: 700; line-height: 1.3; }
.ph-next-line { font-size: 15px; line-height: 1.5; color: var(--shell-ink-66); }

.ph-section { padding: 28px 16px 0; display: flex; flex-direction: column; gap: 10px; }
.ph-section--tiles { gap: 12px; }
.ph-h2 { margin: 0 0 2px; font-size: 12px; font-weight: 700; letter-spacing: 0.14em; text-transform: uppercase; color: var(--shell-ink-60); }
.ph-h2--gap { margin-bottom: 4px; }
.ph-section-head { display: flex; align-items: baseline; justify-content: space-between; }
.ph-main .lib-web { gap: 14px; }
.ph-main .lib-web-part { gap: 10px; }
.ph-main .lib-sub { font-size: 14px; }
.ph-main .wthumb { border-radius: 12px; }
.ph-main .wthumb-body { padding: 12px 14px 14px; }
.ph-main .wthumb-title { font-size: 15px; }
.ph-all { font-size: 13px; font-weight: 700; color: var(--shell-ink); }
.ph-join { margin: 0; font-size: 14px; color: var(--shell-ink-60); }
.ph-join--alone { padding: 28px 16px 0; }
.ph-note { padding: 16px 16px 0; }

.ph-session {
  display: flex; gap: 14px; align-items: center; padding: 12px 14px; border-radius: 12px;
  border: 1px solid var(--shell-ink-10); text-decoration: none; color: var(--shell-ink);
}
.ph-session-text { display: flex; flex-direction: column; gap: 3px; min-width: 0; }
.ph-session-product { display: flex; align-items: center; gap: 7px; font-size: 12px; color: var(--shell-ink-62); }
.ph-session-title { font-size: 15px; font-weight: 700; line-height: 1.3; }
.ph-session-time { font-size: 13px; color: var(--shell-ink-62); }
.ph-session--card { flex-direction: column; align-items: stretch; gap: 12px; }
.ph-session-top { display: flex; gap: 14px; align-items: center; }
.ph-session-actions { display: flex; gap: 8px; padding-left: 58px; }
.ph-session-actions .session-btn { height: 40px; }
.ph-action { font-size: 13px; font-weight: 700; }

.prow {
  display: flex; gap: 14px; padding: 10px; border-radius: 14px; border: 1px solid var(--shell-ink-10);
  background: var(--shell-ink-02); text-decoration: none; color: var(--shell-ink);
}
.prow-body { display: flex; flex-direction: column; gap: 4px; justify-content: center; min-width: 0; flex-grow: 1; }
.prow-name { font-size: 15px; font-weight: 700; line-height: 1.3; }
.prow-status { font-size: 13px; color: var(--shell-ink-66); }
.prow-status--strong { color: var(--shell-ink); }

/* Tile art, phone */
.part {
  width: 108px; height: 96px; flex-shrink: 0; border-radius: 10px; padding: 10px; position: relative; overflow: hidden;
  display: flex; flex-direction: column; justify-content: flex-end;
}
.part--fe { background: var(--fe-bg); justify-content: space-between; }
.part-fe-bar { width: 24px; height: 3px; background: var(--fe-green); }
.part-fe-name { font-family: 'Anton', sans-serif; font-size: 17px; line-height: 1.02; color: var(--fe-text); }
.part--acc { background: var(--acc-bg); }
.part-acc-name { font-family: 'Inter Tight', sans-serif; font-weight: 700; font-size: 15px; line-height: 1.15; color: var(--acc-green); }
.part--masterclass { background: var(--poyt-orange); }
.part-mc-name { font-family: 'Archivo', sans-serif; font-weight: 800; font-size: 13px; line-height: 1.15; color: var(--on-dark); }
.part--pcfl { padding: 0; background: var(--acc-green); }
.part--pcfl img { width: 100%; height: 100%; object-fit: cover; }
.part-pcfl-chip {
  position: absolute; left: 6px; bottom: 6px; width: 30px; height: 30px; border-radius: 7px; background: var(--acc-green);
  display: flex; align-items: center; justify-content: center;
}
.part--poyt { background: var(--poyt-navy); }
.part-poyt-name { font-family: 'Archivo', sans-serif; font-weight: 800; font-size: 15px; line-height: 1.12; color: var(--on-dark); }
.part--master { background: var(--shell-ink-03); }
.part-master-name { font-weight: 800; font-size: 14px; line-height: 1.15; color: var(--shell-ink); }

.ph-free {
  display: flex; gap: 14px; align-items: center; padding: 10px; border-radius: 12px;
  border: 1px solid var(--shell-ink-10); text-decoration: none; color: var(--shell-ink);
}
.ph-free-text { display: flex; flex-direction: column; gap: 3px; min-width: 0; }
.ph-free-name { font-size: 15px; font-weight: 700; line-height: 1.3; }
